import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api';

// Map URL path prefixes to module keys used by the backend growth metrics.
const MODULE_RULES = [
  { test: (p) => p.startsWith('/people') || p.startsWith('/employees') || p.startsWith('/organization'), key: 'people' },
  { test: (p) => p.startsWith('/performance'), key: 'performance' },
  { test: (p) => p.startsWith('/skills') || p.startsWith('/competence'), key: 'skills' },
  { test: (p) => p.startsWith('/payroll') || p.startsWith('/paie'), key: 'payroll' },
  { test: (p) => p.startsWith('/absences') || p.startsWith('/leave'), key: 'leave' },
  { test: (p) => p.startsWith('/training') || p.startsWith('/formation') || p.startsWith('/learning'), key: 'training' },
];

const matchModule = (path) => {
  for (const r of MODULE_RULES) {
    if (r.test(path)) return r.key;
  }
  return null;
};

// Throttle: fire at most one module_view per (module, 5 min window) for the same tab.
const FIRED_KEY = 'hre_module_fired';
const TTL_MS = 5 * 60 * 1000;

const getFiredMap = () => {
  try { return JSON.parse(sessionStorage.getItem(FIRED_KEY) || '{}'); } catch { return {}; }
};
const setFiredMap = (m) => {
  try { sessionStorage.setItem(FIRED_KEY, JSON.stringify(m)); } catch (_) {}
};

export default function useModuleTracking() {
  const location = useLocation();
  const lastFiredRef = useRef(null);

  useEffect(() => {
    const moduleKey = matchModule(location.pathname);
    if (!moduleKey) return;
    if (lastFiredRef.current === moduleKey) return; // same session, same module — skip
    const fired = getFiredMap();
    const now = Date.now();
    if (fired[moduleKey] && now - fired[moduleKey] < TTL_MS) {
      lastFiredRef.current = moduleKey;
      return;
    }
    // Fire & forget — silent on failure (auth not loaded yet, network, etc.)
    api.post('/analytics/track', {
      type: 'module_view',
      metadata: { module: moduleKey, path: location.pathname },
    }).catch(() => {});
    fired[moduleKey] = now;
    setFiredMap(fired);
    lastFiredRef.current = moduleKey;
  }, [location.pathname]);
}
